/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Messaged View Reducer
 */

import { DEFAULT_LISTABLES } from '@zcode/nr/es/shared/bizos/listables'
import { alwaysReducer } from '@zcode/reducers'
import { falseReducer, trueReducer } from '@zcode/reducers'
import type { MessagedView } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  BEGIN_FETCHING_LISTABLES,
  DONE_FETCHING_LISTABLES,
  HIDE,
  RECEIVE_LISTABLES,
  RESET,
} from '../constants/index'

type Actions = ExtractActions<Values<typeof actions>>

const mesasagedViewReducer = combineReducers<MessagedView, Actions>({
  fetchingListables: handleActions(
    {
      [BEGIN_FETCHING_LISTABLES]: trueReducer,
      [DONE_FETCHING_LISTABLES]: falseReducer,
      [HIDE]: falseReducer,
      [RESET]: falseReducer,
    },
    false
  ),
  listables: handleActions(
    {
      [HIDE]: alwaysReducer(DEFAULT_LISTABLES),
      [RESET]: alwaysReducer(DEFAULT_LISTABLES),
      [RECEIVE_LISTABLES]: (state, action) => {
        const { payload } = action
        if (payload.listables) {
          return payload.listables
        }
        return state
      },
    },
    DEFAULT_LISTABLES
  ),
})

export default mesasagedViewReducer
